import { plural } from "@/_providers/Translation"
import { Button } from "@mui/material"
import removeImage from "@/assets/img/reservations/icons/remove.svg"
import Dropdown from "@/components/partials/Dropdown"

export default function ExceptionField({
  index,
  exception,
  onUpdateField,
  onRemove,
}) {
  return (
    <div className="device-container">
      <div className="head">
        {`Изключение ${index + 1}`}
        {onRemove && (
          <Button
            onClick={(e) => {
              e.stopPropagation()
              onRemove(index)
            }}
          >
            <img src={removeImage} alt="Remove" />
          </Button>
        )}
      </div>
      <div className="body">
        <div className="row">
          <div className="col">
            <Dropdown
              inputIdValue={Number(exception.contractor_id)}
              url="contractors/active"
              renderText={(data) => {
                return data.name
              }}
              onChange={(data) => {
                // handleSupplier(data)
              }}
              inputPlaceholder="Изберете компания"
              inputIdName={`exceptions[${index}][contractor_id]`}
              listStyle={{ height: "140px", overflowY: "auto" }}
            />
          </div>
          <div className="col" style={{ width: "fit-content", flexShrink: 0 }}>
            <select
              name={`exceptions[${index}][payment_terms_value]`}
              value={exception.payment_terms_value || 7}
              onChange={(e) =>
                onUpdateField(index, "payment_terms_value", e.target.value)
              }
            >
              <option value="7">До 1 седмица</option>
              <option value="14">До 2 седмици</option>
              <option value="21">До 3 седмици</option>
              <option value="28">До 4 седмици</option>
            </select>
          </div>
          {exception.id ? (
            <input
              type="hidden"
              name={`exceptions[${index}][id]`}
              value={exception.id}
            />
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  )
}
